import { Loading, decryptData, defaulUrl, photoUrl } from "../components/const";
import UseFetch from "../components/UseFetch";
import ModalAddProduct from "./ModalAddProduct";
import { useState } from "react";
import Swal from "sweetalert2";
import ModalEditeProduct from "./ModalEditeProduct";
import ModalImageProduct from "./ModalImageProduct";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const AddProduct = () => {
    const { data: produits, isloading: load, refresh } = UseFetch('produits/liste');
    const [isLoading, setIsLoading] = useState(false);
    const [selectedProduct, SetselectedProduct] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterStockOnly, setFilterStockOnly] = useState(false);

    const handleDelete = (id) => {
        Swal.fire({
            title: "Confirmez votre opération",
            text: 'Souhaitez-vous vraiment supprimer ce produit ?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            confirmButtonColor: "green"
        }).then((rep) => {
            if (rep.isConfirmed) {
                setIsLoading(true);
                fetch(`${defaulUrl}produits/delete/${id}`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
                    }
                }).then((response) => response.json())
                    .then(data => {
                        Swal.fire({
                            title: "Succès",
                            text: data.message,
                            icon: 'success',
                            timer: 5000
                        });
                        setIsLoading(false);
                    }).then(() => refresh());
            }
        });
    };

    // Filtrage combiné : par nom + par stock
    const filteredProduits = produits?.filter(p => {
        const matchName = p.produit.toLowerCase().includes(searchTerm.toLowerCase());
        const matchStock = filterStockOnly ? p.quantite > 0 : true;
        return matchName && matchStock;
    });

    // 🔹 Fonction PDF dynamique simplifiée
    const printTable = (title, tab = []) => {
        const user = decryptData("USER");

        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF();

        // Entête PDF
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes fixes : N°, PRODUIT, QUANTITE
        const headers = ["N°", "PRODUIT", "QUANTITE"];

        // Préparer les données
        const data = tab.map((row, index) => [
            index + 1,
            row.produit?.toUpperCase() || "",
            row.quantite?.toLocaleString() || 0
        ]);

        // Ajouter le tableau
        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        // Générer PDF
        doc.save(`${title || "document"}.pdf`);
    };


    return (
        <div className="container-fluid">
            <div className="row my-2 align-items-center">
                <div className="col-md-4 h2 text-primary">
                    GESTION DES PRODUITS
                </div>
                <div className="col-md-2 text-end ms-auto">
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Nouveau produit
                    </button>
                </div>
            </div>
            <div className="row justify-content-between">
                {isLoading && <div className="loader"></div>}
                <div className="col-md-4">
                    <input
                        type="search"
                        className="form-control"
                        placeholder="🔍 Rechercher un produit..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="col-auto">
                    <button
                        className="btn btn-primary my-2"
                        onClick={() => printTable("LISTE GENERAL DES PRODUITS", filteredProduits)}
                    >
                        <i className="bx bx-printer"></i>
                    </button>
                </div>
            </div>
            {load ? <Loading /> : filteredProduits?.length ? (
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">
                    {filteredProduits.map((p, i) => (
                        <div className="col" key={i}>
                            <div className="card shadow-sm h-100">
                                {(p.images?.length > 0) ? (
                                    <img src={`${photoUrl}produits/${p?.images[0]['image']}`} className="card-img-top" alt="Produit" height="180" />
                                ) : (
                                    <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: "180px" }}>
                                        <button className="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#image-product" onClick={() => SetselectedProduct(p)}>
                                            Ajouter une image
                                        </button>
                                    </div>
                                )}
                                <div className="card-body">
                                    <h5 className="card-title text-primary">{p.produit}</h5>
                                    <p className="card-text">Quantité : <span className="fw-bold">{p.quantite}</span></p>
                                    <p className="card-text text-muted">Ajouté le : {new Date(p.created_at).toLocaleDateString()}</p>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    {(p.images?.length > 0) && <button className="btn btn-outline-primary m-1" data-bs-toggle="modal" data-bs-target="#image-product" onClick={() => SetselectedProduct(p)}>
                                        Modifier l'image
                                    </button>}
                                    <button className="btn btn-sm btn-primary m-1" data-bs-toggle="modal" data-bs-target="#editeProductModal" onClick={() => SetselectedProduct(p)}>
                                        <i className="bx bx-edit"></i>
                                    </button>
                                    <button className="btn btn-sm btn-danger m-1 " onClick={() => handleDelete(p.id)}>
                                        <i className="bx bx-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="p-2 row justify-content-center bg-danger-subtle text-danger fs-4">
                    Aucun produit trouvé !
                </div>
            )}

            {/* Modals */}
            <ModalAddProduct onclose={() => refresh()} />
            <ModalEditeProduct produit={selectedProduct} onclose={() => refresh()} />
            <ModalImageProduct produit={selectedProduct} onclose={() => refresh()} />
        </div>
    );
};

export default AddProduct;
